import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { AppConfigService } from "src/app/app-config.service";
import { CommonService } from "../../common-service";
import { ListBiHealthUnitResponse } from "../../responses/business-intelligence/list-bi-health-unit.response";
import { ListSchedulePowerBiResponse } from "../../responses/business-intelligence/list-schedule-power-bi.response";
import { ListSchedulePowerBiRequest } from "../../requests/business-intelligence/list-schedule-power-bi.request";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";

@Injectable({
  providedIn: 'root'
})
export class SchedulePowerBiService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public getScheduleList(idReport: number, isInternal: boolean = false): Observable<ListSchedulePowerBiResponse> {

    let uri = `SchedulePowerBi/getScheduleList/idReport/${idReport}/isInternal/${isInternal}`

    return this.httpClient.get<ListSchedulePowerBiResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBusinessIntelligence) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateScheduleList(body: ListSchedulePowerBiRequest): Observable<ReturnStruct> {

    let uri = `SchedulePowerBi/updateSchedule`;

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBusinessIntelligence) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

}
